import {Component, OnInit} from '@angular/core';
import {RutasService} from '../../../services/rutas.service';
import {CuadreService} from '../../../services/cuadre.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertasModales} from '../../../helpers/alertasModales';
import * as $ from 'jquery/dist/jquery.min.js';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Helper} from '../../../helpers/helper';
import {EmpleadosServicio} from '../../../services/empleado.service';

const ID_PAGINA = 2;

@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.css']
})
export class ListaComponent implements OnInit {
  rutas = [];
  multiSelectPrestamos: any;
  rutasSeleccionadas = [];
  rutasSeleccionadasAntes = false;
  aperturas = [];
  page = 1;
  limit = 50;
  offset = 0;
  size = 0;
  loaded = false;
  loading = false;
  add = false;
  empleado = '';
  fecha_desde: NgbDateStruct;
  fecha_hasta: NgbDateStruct;
  active: string;
  columnsSort = [];
  private columnsServer = [];
  estadoSeleccionado = '';


  constructor(
    private rutaService: RutasService,
    private cuadreService: CuadreService,
    private route: ActivatedRoute,
    private empleadoService: EmpleadosServicio,
    private router: Router,
    private helper: Helper,
    private modals: AlertasModales) {

    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
    this.initRutas();
    /*if ( localStorage.getItem('rutasSeleccionadas')) {
      this.rutasSeleccionadas = JSON.parse(localStorage.getItem('rutasSeleccionadas'));
    }*/
    this.rutasSeleccionadas = rutaService.getSelectedRoutes();
    if (this.rutasSeleccionadas.length > 0) {
      this.rutasSeleccionadasAntes = true;
    }
    this.initColumns();
  }

  ngOnInit() {
    this.verificarQueryString();
    this.initConfigMultiSelect();

    $('.modal-dialog modal-lg').addClass('modal-xl');
  }

  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas()
      .subscribe(rutas => {
        for (const ruta of rutas.rutas) {
          this.rutas.push({
            id: ruta.ID_RUTA,
            itemName: String(ruta.nombre)
          });
        }
      });
  }

  private initAperturas(): void {
    this.loading = true;
    let fecha_desde = '';
    let fecha_hasta = '';
    if (this.fecha_desde) {
      fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta) {
      fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }

    this.cuadreService.obtenerAperturas(
      this.limit,
      this.offset,
      this.rutasSeleccionadas.map(data => data.id).join(),
      this.empleado,
      fecha_desde,
      fecha_hasta,
      JSON.stringify(this.columnsServer),
      this.estadoSeleccionado
    ).subscribe(res => {
      this.aperturas = res.aperturas;
      this.size = res.total_items;
      this.active = localStorage.getItem('apertura_active') || '';

      setTimeout(() => {
        this.loaded = true;
        this.loading = false;
      }, 1);
    });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (params.estado) {
          this.estadoSeleccionado = params.estado;
        }
        if (params.empleado) {
          this.empleado = params.empleado;
        }
        if (params.limite && !isNaN(params.limite)) {
          this.limit = params.limite;
        }
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }

        if (params.fecha_inicia) {
          const yearInit = parseFloat(params.fecha_inicia.split('-')[0]);
          const monthInit = parseFloat(params.fecha_inicia.split('-')[1]);
          const dayInit = parseFloat(params.fecha_inicia.split('-')[2]);

          if (!isNaN(yearInit) && !isNaN(monthInit) && !isNaN(dayInit)) {
            this.fecha_desde = {year: yearInit, month: monthInit, day: dayInit};
          }
        }

        if (params.fecha_termina) {
          const yearEnd = parseFloat(params.fecha_termina.split('-')[0]);
          const monthEnd = parseFloat(params.fecha_termina.split('-')[1]);
          const dayEnd = parseFloat(params.fecha_termina.split('-')[2]);

          if (!isNaN(yearEnd) && !isNaN(monthEnd) && !isNaN(dayEnd)) {
            this.fecha_hasta = {year: yearEnd, month: monthEnd, day: dayEnd};
          }
        }

        if (params.rutas) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }
          if (this.rutas.length > 0) {
            this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          }
        }
        if  (this.rutasSeleccionadas.length > 0)  {

          this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          this.rutasSeleccionadasAntes = false;
        } else {
          if  (this.rutasSeleccionadasAntes) {
            this.rutasSeleccionadas = this.rutaService.getSelectedRoutes();
            this.rutasSeleccionadasAntes = false;
          } else  {
            this.rutaService.removeSelectedRoutes();
          }

        }
        this.columnsServer = [];
        // tslint:disable-next-line:forin
        for (const columnParams in params) {
          for (const column of this.columnsSort) {
            if (column.label.replace(/\s/g, '').toLowerCase() === columnParams.replace('order', '')) {
              if (params[columnParams].toLowerCase() === 'asc' || params[columnParams].toLowerCase() === 'desc') {
                column.order = params[columnParams].toLowerCase();
                this.columnsServer.push(column);
                break;
              }
            }
          }
        }
        this.initAperturas();
      }
    });
  }

  private initConfigMultiSelect() {
    this.multiSelectPrestamos = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 3,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  public loadPage(page: number) {
    this.page = page;
    this.offset = this.limit * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./lista/apertura-dia'], {queryParams: queryParams});
    this.initAperturas();
  }

  public filtrarApertura() {
    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['estado'] = this.estadoSeleccionado;
    queryParams['empleado'] = this.empleado;
    queryParams['limite'] = this.limit;
    const rutas = this.rutasSeleccionadas.map(data => data.id).join();
    if (rutas) {
      queryParams['rutas'] = rutas;
    } else {
      delete queryParams['rutas'];
    }

    if (
      this.fecha_desde !== undefined &&
      this.fecha_desde !== null &&
      this.fecha_desde.year !== null
    ) {
      queryParams['fecha_inicia'] = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (
      this.fecha_hasta !== undefined &&
      this.fecha_hasta !== null &&
      this.fecha_hasta.year !== null
    ) {
      queryParams['fecha_termina'] = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }

    this.router.navigate(['./lista/apertura-dia'], {queryParams: queryParams});
  }

  public detalleApertura(apertura, i): void {
    localStorage.setItem('apertura_active', (apertura.ID_APERTURA_DIA));
    this.active = apertura.ID_APERTURA_DIA;

    this.add = false;
    this.modals.detalleAperturaNgbModal(apertura).then(res => {
      if (res) {
        this.aperturas[i].capital += res.capital;
        setTimeout(() => this.add = true, 1);
      }
    });
  }

  cerrarDia(apertura, i) {
    localStorage.setItem('apertura_active', (apertura.ID_APERTURA_DIA));
    this.active = apertura.ID_APERTURA_DIA;

    if (apertura.estado !== 3) {
      const functions = {
        _parent: this
      };

      this.modals.cerrarDiaNgbModal(apertura, i, functions).then(res => {
        if (res) {
          this.aperturas[i].estado = res.estado;
        }
      });
    } else {
      const functions = {
        _parent: this
      };
      this.modals.detalleCerrarDiaNgbModal(apertura, i, functions);
    }
  }

  editarApertura(apertura) {
    localStorage.setItem('apertura_active', (apertura.ID_APERTURA_DIA));
    this.active = apertura.ID_APERTURA_DIA;
    this.modals.editarAperturaNgbModal(apertura.ID_APERTURA_DIA)
      .then(() => this.initAperturas());
  }

  reabrir(apertura) {
    localStorage.setItem('apertura_active', (apertura.ID_APERTURA_DIA));
    this.active = apertura.ID_APERTURA_DIA;

    let msg = `<h4>Reabrir cuadre de <b>${apertura.ruta.toLowerCase()}</b></h4>`;
    msg += '<p>Con esta acción el cuadre cambiará su estado a verificado y tendrás acceso a editar el cuadre, y cerrarlo de nuevo.</p>';
    this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange')
      .then(res => {
        if (res === 'SI') {
          this.cuadreService.reabrirApertura(apertura.ID_APERTURA_DIA)
            .subscribe(() => {
              apertura.estado = 2;
            }, err => {
              if (err.status == 403) {
                this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
                  'red',
                  'modern',
                  false,
                  'fa fa-file-text');
              } else {
                this.initAperturas()
              }
            });
        }
      });
  }

  eliminar(apertura, i) {
    localStorage.setItem('apertura_active', (apertura.ID_APERTURA_DIA));
    this.active = apertura.ID_APERTURA_DIA;

    const msg = `Eliminar la apertura de <b>${apertura.ruta.toLowerCase()}</b>`;
    this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange')
      .then(res => {
        if (res === 'SI') {
          this.cuadreService.eliminarApertura(apertura.ID_APERTURA_DIA)
            .subscribe(() => this.aperturas.splice(i, 1),
              err => {
                if (err.status === 401 && err.error === 'reload') {
                  this.initAperturas();
                } else if (err.status == 403) {
                  this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
                    'red',
                    'modern',
                    false,
                    'fa fa-file-text');
                }
              });
        }
      });
  }

  orderTable(column) {
    if (!column.order) {
      column.order = 'desc';
    } else {
      column.order = column.order === 'desc' ? 'asc' : 'desc';
    }
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`];
    queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`] = column.order;
    this.router.navigate(['./lista/apertura-dia'], {queryParams: queryParams});
  }

  private initColumns(): void {
    this.columnsSort = [
      {
        label: 'Zona',
        column: 'ruta',
        order: ''
      },
      {
        label: 'Fecha de apertura',
        column: 'a.fecha_apertura',
        order: ''
      },
      {
        label: 'Capital',
        column: 'a.capital',
        order: ''
      },
      {
        label: 'Entregado',
        column: 'recibidoPor',
        order: ''
      },
      {
        label: 'Aperturado por',
        column: 'aperturadoPor',
        order: ''
      },
      {
        label: 'Notas',
        column: 'a.nota_adicional',
        order: ''
      },
      {
        label: 'Estado',
        column: 'a.estado',
        order: ''
      }
    ];
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/aperturar-dia/lista/lista.component.ts